import { config } from '../../../config';

export interface DriverRequest {
    vin: string;
    driver_identification: {
        identification_type: string;
        identification: string;
    };
    username: {
        preferred_login: 'phone' | 'email';
        value: string;
    };
    communication_language: string;
}

export interface DriverSubmissionResult {
    status: number;
    title?: string;
}

/**
 * In 'user-self-registration-service' -> see:
 * - /src/main/kotlin/cloud/rio/iam/selfregistration/application/Errors.kt
 * - /src/main/kotlin/cloud/rio/iam/selfregistration/web/controller/extensions/ErrorExtensions.kt
 */
const firstScreenValidationErrorTitles = [
    'DRIVER_DRIVER_IN_MULTIPLE_FLEETS',
    'DRIVER_NONE_FOUND',
    'DRIVER_DRIVER_CARD_NUMBER_VALIDATION_FAILED',
    'DRIVER_VIN_VALIDATION_FAILED',
] as const;

export const isFirstScreenValidationError = ({ status, title }: DriverSubmissionResult): boolean =>
    status === 400 &&
    firstScreenValidationErrorTitles.includes(title as (typeof firstScreenValidationErrorTitles)[number]);

export const parseResponseTitle = async (response: Response): Promise<string | undefined> => {
    try {
        const body = await response.text();

        if (!body) {
            return undefined;
        }

        const parsedBody = JSON.parse(body) as { title?: unknown };
        return typeof parsedBody.title === 'string' ? parsedBody.title : undefined;
    } catch {
        return undefined;
    }
};

export const submitDriverRequest = async (driverRequest: DriverRequest): Promise<DriverSubmissionResult> => {
    const url = `${config.backend.userSelfRegistration}/driver-registrations`;

    const postRequest = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(driverRequest),
    };

    const response = await fetch(url, postRequest);

    return {
        status: response.status,
        title: response.status === 400 ? await parseResponseTitle(response) : undefined,
    };
};
